import React from 'react';
import PropTypes from 'prop-types';
import SeasonPicker from './SeasonPicker';
import ShiftTabs from './ShiftTabs';
import CreateShiftButton from './CreateShiftButton';
import TopbarActions from './TopbarActions';
import { MenuIcon } from '../model/icons';

// <header class="topbar-app"> — контекст смены: сезон + табы смен + создание,
// действия (колокол/аватар) в правом гаттере. Бургер открывает sidebar на мобиле.
export default function Topbar({ seasons, shifts, refetchShifts, onBurgerClick }) {
    return (
        <header className="topbar-app">
            <div className="topbar-in">
                <button type="button" className="burger" onClick={onBurgerClick} aria-label="Меню">
                    <MenuIcon />
                </button>
                <SeasonPicker seasons={seasons} />
                <ShiftTabs shifts={shifts} />
                <CreateShiftButton refetchShifts={refetchShifts} />
            </div>
            <TopbarActions />
        </header>
    );
}

Topbar.propTypes = {
    seasons: PropTypes.arrayOf(PropTypes.string).isRequired,
    shifts: PropTypes.array.isRequired,
    refetchShifts: PropTypes.func.isRequired,
    onBurgerClick: PropTypes.func.isRequired
};
